import { gql } from '@apollo/client';

export const DELETE_BAKER_USER_MUTATION = gql`
  mutation DeleteBakerUser($userDeleteDto: UserDeleteDto!) {
    deleteBakerUser(userDeleteDto: $userDeleteDto) {
      success
      errorMessage
    }
  }
`;
